import { types, getParent } from 'mobx-state-tree';
import { ViewStore } from './ViewStore';
import { Application, Pagination } from 'feathers';
import { ApplicationState } from '../services/ApplicationState';

export const AppStore = types.model('AppStore', {
  id: types.optional(types.identifier(types.string), 'appStore'),
  name: types.string,
  view: ViewStore,
  state: types.optional(types.enumeration('state', ['pending', 'done']), 'pending'),
  applicationState: types.maybe(ApplicationState),

  get client(): Application {
    return getParent(this).client;
  },

  get hasApplicationState() {
    return this.applicationState !== null && this.applicationState !== undefined;
  }
}, {
    afterCreate() {
      if (this.client && this.client.service(ApplicationState.name)) {
        this.client.service(ApplicationState.name).find({
          query: {
            name: this.name
          }
        }).then(result => {
          const paginatedResult = result as Pagination<typeof ApplicationState.SnapshotType>;
          return paginatedResult.total !== 0 ? paginatedResult.data[0] : null;
        }).then(this.setAppState);
      }
    },

    setAppState(appState: typeof ApplicationState.SnapshotType | null) {
      this.applicationState = appState ? ApplicationState.create(appState) : null;
      this.state = 'done';
    },

    initialize(customerId: number, customerName: string) {
      this.client.service(ApplicationState.name).create({
        name: this.name,
        customerId,
        customerName,
        initialized: new Date(),
        updated: new Date()
      }).then(result => result as typeof ApplicationState.SnapshotType)
        .then(this.setAppState);
    },
  });


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/common/stores/AppStore.ts